import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { selectLeftMenuLinks } from 'util/selector/navigationSelector';

import { update } from '@intercom/messenger-js-sdk';
import { getNavigationNodeKey, NavigationNode } from 'model/NavigationNode';

const collectNodeKeys = (nodes: NavigationNode[]): string[] =>
  nodes
    .filter((node) => !node.isLoading)
    .flatMap((node) => [getNavigationNodeKey(node), ...collectNodeKeys(node.children ?? [])]);

export const useRescanIntercom = (isBooted: boolean) => {
  const links = useSelector(selectLeftMenuLinks);
  const menuKey = useMemo(() => collectNodeKeys(links).join('|'), [links]);
  const lastMenuKeyRef = useRef(menuKey);

  // Intercom scans for tooltip targets only on boot and on update(), and throttles update()
  // to 20 calls per 30 minutes, so re-scan only when the menu content actually changes
  useEffect(() => {
    const hasMenuChanged = lastMenuKeyRef.current !== menuKey;
    lastMenuKeyRef.current = menuKey;

    if (isBooted && hasMenuChanged) {
      update({});
    }
  }, [isBooted, menuKey]);
};
